import { createContext, useState, useEffect, useContext, useRef, useCallback } from "react";
import UserService from "../services/UserService";
import ShopContext from "./ShopContext";

const UserContext = createContext();

let cachedUser = null;
let userPromise = null;

export function UserProvider(props) {
  const { shopId } = useContext(ShopContext);

  const [user, setUser] = useState(cachedUser);
  const loadingRef = useRef(false);

  const handleSetUser = useCallback((newUser) => {
    cachedUser = newUser;
    if (!newUser) {
      userPromise = null;
    }
    setUser(newUser);
  }, []);

  const loadUserProfile = useCallback(async () => {
    if (loadingRef.current || user) return;

    if (cachedUser) {
      setUser(cachedUser);
      return;
    }

    loadingRef.current = true;
    try {
      if (!userPromise) {
        userPromise = UserService.getUserProfile();
      }
      const resUser = await userPromise;
      if (resUser) {
        cachedUser = resUser;
        setUser(resUser);
      }
    } catch (err) {
      console.error("loadUserProfile error", err);
      userPromise = null;
    } finally {
      loadingRef.current = false;
    }
  }, [user]);

  useEffect(() => {
    if (shopId && !user) {
      loadUserProfile();
    }
  }, [shopId, user, loadUserProfile]);

  return (
    <UserContext.Provider value={{ user, setUser: handleSetUser, loadUserProfile }}>
      {props.children}
    </UserContext.Provider>
  );
}

export default UserContext;
